import type { ScrollControllerContext } from "./scroll-controller-types";
import type { ScrollActions } from "./use-scroll-actions";
import { useScrollContainerObserver } from "./use-scroll-container-observer";
import type { ScrollControllerRefs } from "./use-scroll-controller-refs";
import { useScrollContextReset } from "./use-scroll-context-reset";
import { useScrollInterruptionListeners } from "./use-scroll-interruption-listeners";
import type { ScrollNearBottomState } from "./use-scroll-near-bottom-state";
import { useScrollPositionTracking } from "./use-scroll-position-tracking";

interface UseScrollControllerEffectsInput {
  context: ScrollControllerContext;
  scrollRef: React.RefObject<HTMLDivElement | null>;
  refs: ScrollControllerRefs;
  nearBottom: ScrollNearBottomState;
  actions: ScrollActions;
}

export function useScrollControllerEffects({
  context,
  scrollRef,
  refs,
  nearBottom,
  actions,
}: UseScrollControllerEffectsInput): void {
  useScrollContainerObserver({
    scrollRef,
    observerRef: refs.observerRef,
    visibleMessageIdsRef: refs.visibleMessageIdsRef,
    messageElementsRef: refs.messageElementsRef,
    versionElementsRef: refs.versionElementsRef,
    elementToMessageIdRef: refs.elementToMessageIdRef,
    pendingScrollRef: refs.pendingScrollRef,
    updateNearBottom: nearBottom.updateNearBottom,
    scrollToBottom: actions.scrollToBottom,
    scrollToMessageId: actions.scrollToMessageId,
    scrollToVersionId: actions.scrollToVersionId,
  });

  useScrollInterruptionListeners({
    scrollRef,
    isAutoScrollingRef: refs.isAutoScrollingRef,
    cancelAutoScroll: actions.cancelAutoScroll,
  });

  useScrollPositionTracking({
    scrollRef,
    isAutoScrollingRef: refs.isAutoScrollingRef,
    pendingScrollRef: refs.pendingScrollRef,
    runIdRef: refs.runIdRef,
    updateNearBottom: nearBottom.updateNearBottom,
  });

  useScrollContextReset({
    context,
    cancelAutoScroll: actions.cancelAutoScroll,
    setShowJumpToLatest: nearBottom.setShowJumpToLatest,
  });
}
